import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { EMAIL, PHONE, PHONE_DISPLAY, SERVICE_AREA } from "../data/site";

export const Footer = () => {
  return (
    <footer className="bg-navy text-white" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-16 lg:py-20">
        <div className="grid gap-12 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-3">
              <span className="grid place-items-center h-16 w-16 rounded-2xl bg-white p-1.5">
                <img
                  src="/logo.png"
                  alt="Second Chance CPR logo"
                  className="h-full w-full object-contain"
                />
              </span>
              <span className="font-editorial text-2xl font-bold leading-none">
                Second Chance CPR
              </span>
            </div>
            <p className="mt-3 font-editorial italic text-[#5eead4] text-sm">
              Learn Today. Save Lives Tomorrow.
            </p>
            <p className="mt-5 max-w-sm text-slate-300 leading-relaxed font-body">
              Hands-on CPR, AED, First Aid, and BLS training that builds real
              confidence for when every second counts.
            </p>
          </div>

          <div className="md:justify-self-center">
            <h4 className="font-grotesk text-sm uppercase tracking-[0.2em] text-teal-300 text-[#5eead4]">
              Explore
            </h4>
            <ul className="mt-5 space-y-3 font-body">
              <li>
                <Link to="/" className="text-slate-300 hover:text-white transition-colors" data-testid="footer-home">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/courses" className="text-slate-300 hover:text-white transition-colors" data-testid="footer-courses">
                  Courses
                </Link>
              </li>
              <li>
                <Link to="/courses#contact" className="text-slate-300 hover:text-white transition-colors" data-testid="footer-contact">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-slate-300 hover:text-white transition-colors" data-testid="footer-privacy">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:justify-self-end">
            <h4 className="font-grotesk text-sm uppercase tracking-[0.2em] text-[#5eead4]">
              Get in Touch
            </h4>
            <ul className="mt-5 space-y-4 font-body">
              <li className="flex items-center gap-3 text-slate-300">
                <Mail className="h-5 w-5 text-red-accent shrink-0" />
                <a href={`mailto:${EMAIL}`} className="hover:text-white transition-colors break-all" data-testid="footer-email">
                  {EMAIL}
                </a>
              </li>
              <li className="flex items-center gap-3 text-slate-300">
                <Phone className="h-5 w-5 text-red-accent shrink-0" />
                <a href={`tel:${PHONE}`} className="hover:text-white transition-colors" data-testid="footer-phone">
                  {PHONE_DISPLAY}
                </a>
              </li>
              <li className="flex items-center gap-3 text-slate-300">
                <MapPin className="h-5 w-5 text-red-accent shrink-0" />
                <span>Service Area: {SERVICE_AREA}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-body text-sm text-slate-400">
            Copyright © 2026 Second Chance CPR
          </p>
          <p className="font-body text-sm text-slate-400">Missouri</p>
        </div>
      </div>
    </footer>
  );
};
